import {Ten99Filters} from 'Agent/1099s/ducks/1099';
import {Ten99Filters_V2} from 'Agent/1099s/ducks/1099_v2';
import {TaxStatementsApi} from 'Agent/Commissions/api';
import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import axiosInstance from 'Shared/utilities/axiosInstance';
import { Sort, toSortQuerystringParams } from 'Shared/components/PagedView/Table/Sort';

export const ten99RootUri = '/commissions/taxStatements';

const ten99Api = new TaxStatementsApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

const getTen99s = (encryptedIdentifier: string, isNewYork: boolean, filter?: Ten99Filters, sort?: Sort) =>
  withCancellation(cancelToken =>
    ten99Api.searchTaxStatements('1', {
      ...getAxiosConfig(cancelToken),
      params: {encryptedIdentifier, isNewYork, ...filter, ...(sort && toSortQuerystringParams(sort))},
    })
  ).then(handleResponse);

const getTen99s_V2 = (encryptedIdentifier: string, isNewYork: boolean, taxYear: string, filter?: Ten99Filters_V2, sort?: Sort) =>
  withCancellation(cancelToken =>
    ten99Api.searchTaxStatements('1', {
      ...getAxiosConfig(cancelToken),
      params: {encryptedIdentifier, isNewYork, taxYear, ...filter, ...(sort && toSortQuerystringParams(sort))},
    })
  ).then(handleResponse);

export default {
  getTen99s,
  getTen99s_V2,
};
